export default function SectionContact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
          联系我们
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
          有想看的综艺节目？欢迎联系我们投稿或反馈建议
        </p>

        <div className="mt-8 bg-background-50 rounded-2xl p-8 md:p-10">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center">
                <i className="ri-mail-line text-primary-600 text-xl"></i>
              </div>
              <div className="text-left">
                <p className="text-xs text-foreground-600">投稿邮箱</p>
                <p className="text-sm font-bold text-foreground-950">feedback@jisucinema.com</p>
              </div>
            </div>
            <div className="hidden sm:block w-px h-12 bg-background-200"></div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-wechat-line text-accent-600 text-xl"></i>
              </div>
              <div className="text-left">
                <p className="text-xs text-foreground-600">官方公众号</p>
                <p className="text-sm font-bold text-foreground-950">极速影院</p>
              </div>
            </div>
            <div className="hidden sm:block w-px h-12 bg-background-200"></div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center">
                <i className="ri-timer-line text-primary-600 text-xl"></i>
              </div>
              <div className="text-left">
                <p className="text-xs text-foreground-600">工作时间</p>
                <p className="text-sm font-bold text-foreground-950">每日 9:00 - 22:00</p>
              </div>
            </div>
          </div>
          <p className="mt-6 text-xs text-foreground-500">
            我们会在收到反馈后的24小时内回复，感谢你对极速影院的支持！
          </p>
        </div>
      </div>
    </section>
  );
}